<template>
  <div class="signed-in-no-trip" :class="signInWithNoTripsMap ? 'signed-in-with-no-trips-map' : ''"
    v-click-outside="close">
    <div class="container">
      <div class="box">
        <div class="select-a-trip">
          <span class="select-a-trip-tx">Select a Trip</span>
        </div>
        <div class="no-trip">
          <div class="no-trip-container">
            <div class="no-trip-container-tx">You will need to create a trip first.</div>
            <div class="curved-down-arrow"><img src="../../public/images/icons/curved-down-arrow.svg" /></div>
          </div>
        </div>
        <div class="create-a-trip">
          <div class="create-a-trip-container">
            <span v-b-modal.create-a-trip-modal class="create-a-trip-tx" @click="createTripWithLocation">+ Create a New
              Trip</span>
          </div>
          <b-modal id="create-a-trip-modal" hide-header hide-footer hide-backdrop scrollable>
            <Destination />
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Destination from '../components/MyTrips/Destination.vue';

export default {
  name: 'overlay-signed-in-with-trip',
  components: { Destination },
  props: {
    objectid: {
      type: String,
    },
    slug: {
      type: String,
    },
    signInWithNoTripsMap: {
      type: Boolean,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      trips: 'myTrips/myTrips',
    }),
  },
  methods: {
    ...mapActions({
      getTrips: 'myTrips/loadMyTrips',
      setNewTripItem: 'myTrips/setNewTripItem',
    }),
    async createTripWithLocation() {
      await this.$root.$emit('enableHeart', this.$props.objectid);
      await this.setNewTripItem({
        slug: this.slug,
        locationId: this.objectid,
      });
    },
    close() {
      this.$root.$emit('hideOSINT', false);
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        // eslint-disable-next-line
        el.clickOutsideEvent = function (event) {
          event.stopPropagation();
          // here I check that click was outside the el and his childrens
          if (!(el === event.target || el.contains(event.target) || document.querySelector('#destination'))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style>
/* Override bootstrap modal backdrop and content classes */
div>div.modal {
  background-color: #fff;
  opacity: 0.98;
}

div>div.modal .modal-content {
  border: none;
}
</style>

<style scoped>
.signed-in-no-trip {
  position: absolute;
  left: -135px !important;
  margin-top: 5px;
  z-index: 999;
}

.signed-in-with-no-trips-map {
  left: 5px !important;
}

.select-a-trip {
  grid-area: select-a-trip;
  height: 20px;
  border-bottom: 1px solid #eaeaea;
  font-family: 'IdealSans-Medium';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1a3138;
  margin-top: 7px;
}

.no-trip {
  grid-area: no-trip;
  height: 140px;
}

.create-a-trip {
  grid-area: create-a-trip;
  border-top: 1px solid #eaeaea;
}

.create-a-trip-tx,
.close-overlay {
  font-family: 'IdealSans-Medium';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1a3138;
  cursor: pointer;
}

.select-a-trip-tx,
.no-trip-container,
.create-a-trip-container {
  margin-left: 9px;
  text-align: left;
}

.no-trip-container {
  width: 153px;
  margin: 30px auto 59px;
  font-family: "KlinicSlabbold";
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.29px;
}

.no-trip-container-tx {
  text-align: center;
}

.curved-down-arrow {
  margin-left: 12px;
}

.no-trip {
  height: 135px;
}

.box {
  display: grid;
  width: 186px;
  height: 200px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  border: 1px solid #eaeaea;
  background: #fff;
  cursor: default;
  grid-template-areas: 'select-a-trip'
    'no-trip'
    'create-a-trip';
}

input {
  min-width: 10px !important;
}
</style>
